module.exports = __webpack_public_path__ + "static/media/challengeIcon.3e709292.svg";